/* eslint-disable max-len */
import 'react';

const SearchGrayBgSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = `SearchGrayBgSvg_1_${Date.now()}`;
    return (
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <defs>
                <rect id={`path-${id}`} x="0" y="0" width="20" height="20"></rect>
            </defs>
            <g id="sug-搜索icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="矩形">
                    <use fill="#FFFFFF" xlinkHref={`#path-${id}`}></use>
                    <use fill="#F5F8FC" xlinkHref={`#path-${id}`}></use>
                </g>
                <path d="M13.64833,5.71910022 C15.6189868,7.68975698 15.8217692,10.75883 14.2566773,12.9555429 L16.1219028,14.8217991 C16.3415727,15.041469 16.3415727,15.3976243 16.1219028,15.6172942 C15.9241999,15.8149971 15.6159438,15.8347674 15.3961302,15.6766051 L15.3264077,15.6172942 L13.5128544,13.8035759 L13.4621709,13.8520248 C11.25482,15.8690557 7.82905845,15.8097312 5.69337873,13.6740515 C3.49667959,11.4773524 3.49667959,7.91579936 5.69337873,5.71910022 C7.89007787,3.52240108 11.4516309,3.52240108 13.64833,5.71910022 Z M6.48887386,6.51459535 C4.73151455,8.27195466 4.73151455,11.1211971 6.48887386,12.8785564 C8.24623318,14.6359157 11.0954756,14.6359157 12.8528349,12.8785564 C14.6101942,11.1211971 14.6101942,8.27195466 12.8528349,6.51459535 C11.0954756,4.75723604 8.24623318,4.75723604 6.48887386,6.51459535 Z" id="形状结合" fill="#D0D3D9" fillRule="nonzero"></path>
            </g>
        </svg>
    );
};
export default SearchGrayBgSvg;
